/**
 * @generated SignedSource<<362b895b77f4f00ddfd0893ac047fe08>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentAbout_AtlassianConversationAssistantAgent_AgentAboutCard$data = {
  readonly " $fragmentSpreads": FragmentRefs<"knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioListRef">;
  readonly " $fragmentType": "agentAbout_AtlassianConversationAssistantAgent_AgentAboutCard";
};
export type agentAbout_AtlassianConversationAssistantAgent_AgentAboutCard$key = {
  readonly " $data"?: agentAbout_AtlassianConversationAssistantAgent_AgentAboutCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"agentAbout_AtlassianConversationAssistantAgent_AgentAboutCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "agentAbout_AtlassianConversationAssistantAgent_AgentAboutCard",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioListRef"
    }
  ],
  "type": "AgentStudioScenariosResult"
};

(node as any).hash = "e85d427c13ee2aca41771738da681b0a";

export default node;
